// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    RESTJobStatistics,
    RESTLinkHAL,
} from './';

/**
 * @export
 * @interface RESTJobSession
 */
export interface RESTJobSession {
    /**
     * Job session ID.
     * @type {string}
     * @memberof RESTJobSession
     */
    id?: string;
    /**
     * Job ID.
     * @type {string}
     * @memberof RESTJobSession
     */
    jobId?: string;
    /**
     * Backup repository ID.
     * @type {string}
     * @memberof RESTJobSession
     */
    repositoryId?: string;
    /**
     * ID of a main job session that has been finished with an error or warning. This property is only available for retry sessions.
     * @type {string}
     * @memberof RESTJobSession
     */
    mainSessionId?: string;
    /**
     * Job session details.
     * @type {string}
     * @memberof RESTJobSession
     */
    details?: string | null;
    /**
     * Date and time when the job session was created.
     * @type {string}
     * @memberof RESTJobSession
     */
    creationTime?: string;
    /**
     * Date and time when the latest job session ended.
     * @type {string}
     * @memberof RESTJobSession
     */
    endTime?: string | null;
    /**
     * Order number of the job session retry.
     * @type {number}
     * @memberof RESTJobSession
     */
    retryCount?: number;
    /**
     * Defines whether the job session will be restarted.
     * @type {boolean}
     * @memberof RESTJobSession
     */
    jobWillBeRetried?: boolean | null;
    /**
     * Number of processed objects during the job session.
     * @type {number}
     * @memberof RESTJobSession
     */
    progress?: number;
    /**
     * Type of the job session.
     * @type {string}
     * @memberof RESTJobSession
     */
    jobType?: RESTJobSessionJobTypeEnum;
    /**
     * Type of the job synchronization.
     * @type {string}
     * @memberof RESTJobSession
     */
    jobSessionConfigType?: RESTJobSessionJobSessionConfigTypeEnum;
    /**
     * Status of the backup or backup copy job.
     * @type {string}
     * @memberof RESTJobSession
     */
    status?: RESTJobSessionStatusEnum;
    /**
     * @type {RESTJobStatistics}
     * @memberof RESTJobSession
     */
    statistics?: RESTJobStatistics;
    /**
     * Version number that Veeam Backup for Microsoft 365 assigns if the job session was modified.
     * @type {number}
     * @memberof RESTJobSession
     */
    eTag?: number;
    /**
     * Related resources.
     * @type {{ [key: string]: RESTLinkHAL; }}
     * @memberof RESTJobSession
     */
    _links?: { [key: string]: RESTLinkHAL; };
    /**
     * Backup proxy server ID.
     * @type {string}
     * @memberof RESTJobSession
     */
    proxyId?: string | null;
    /**
     * Backup proxy pool ID.
     * @type {string}
     * @memberof RESTJobSession
     */
    proxyPoolId?: string | null;
}

/**
 * @export
 * @enum {string}
 */
export enum RESTJobSessionJobTypeEnum {
    Backup = 'Backup',
    Copy = 'Copy'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTJobSessionJobSessionConfigTypeEnum {
    Full = 'Full',
    Incremental = 'Incremental'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTJobSessionStatusEnum {
    Stopped = 'Stopped',
    Running = 'Running',
    Success = 'Success',
    Failed = 'Failed',
    Warning = 'Warning',
    NotConfigured = 'NotConfigured',
    Disconnected = 'Disconnected',
    Queued = 'Queued'
}

